// extracted by mini-css-extract-plugin
export default {"modalTitle":"report-card-modal_modalTitle__ejf7p","modalTitleDivider":"report-card-modal_modalTitleDivider__9S9Ve"};